<vi-page [sidenavs]="true" [footer]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <ng-container body>
    <div class="summary" *ngIf="bookingStore.selectedDevices$ | async as selectedDevices" main>
      <p class="summary__header">
        {{ '+BOOKING.VOUCHER.SUMMARY.TITLE' | translate }}
      </p>
      <p class="summary__package-info">
        {{ '+BOOKING.VOUCHER.SUMMARY.PACKAGE_INFO' | translate }}
      </p>

      <div class="summary__buttons-wrapper">
        <button
          data-at-go-to-devices-button
          gtm="onGoToPage"
          gtmAction="Booking overview"
          gtmCategory="bookingSummary"
          mat-stroked-button
          class="summary__overview-button"
          [routerLink]="['/booking-overview']"
        >
          <span>{{ 'SHARED.SIDENAV.BOOKING_OVERVIEW' | translate }}</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
        <button
          data-at-go-to-devices-button
          gtm="onGoToPage"
          gtmAction="Installation details"
          gtmCategory="bookingSummary"
          mat-raised-button
          color="primary"
          class="summary__to-devices-button"
          [routerLink]="bookingService.getRouterLinkAfterPurchase(selectedDevices)"
        >
          <span *ngIf="selectedDevices.length === 1">
            {{ '+BOOKING.SUBSCRIPTION_SUMMARY.GO_TO_DEVICE' | translate }}
          </span>
          <span *ngIf="selectedDevices.length > 1">
            {{ '+BOOKING.SUBSCRIPTION_SUMMARY.INSTALLATIONS_REDIRECTION' | translate }}
          </span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
